<template>
    <div :class="strainContainer">
        <div class="title">Activity Strain</div>
        <div v-if="activityData" id="strain" class="position-relative" :class="canvasDivClass"
            style="display: inline-block;padding-top: 1rem;">
            <canvas :id="chartId" class="donut-canvas" :ref="chartId" width="110px" height="110px"></canvas>
            <div class="position-absolute top-50 translate-middle-y" style="width: 110px;padding-top: 1.5rem;;">
                <div class="text-center text-xs text-uppercase">Strain</div>
                <div class="text-center font-sans-serif mt-1">{{ this.strain }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';
import Constants from "@/helpers/constants.js";

export default {
    name: 'ActivityStrain',
    props: {
        chartId: {
            type: String,
            default: "activityStrain"
        },
        activityData: {
            type: Object,
            required: false
        },
        statsAvilable: {
            type: Boolean,
            required: false
        },
    },
    mounted() {
        this.strain = this.activityData.strain;
        this.initChart();
        this.canvasDivClass = this.statsAvilable ? "canvas-div-size" : "canvas-div-size-min";
        this.strainContainer = this.statsAvilable ? "strain-container" : "strain-container-min";
    },
    watch: {
        statsAvilable() {
            this.canvasDivClass = this.statsAvilable ? "canvas-div-size" : "canvas-div-size-min";
            this.strainContainer = this.statsAvilable ? "strain-container" : "strain-container-min";
        },
    },
    data() {
        return {
            strain: 16,
            canvasDivClass: "canvas-div-size",
            strainContainer: "strain-container",
        };
    },
    methods: {
        initChart() {
            let strainChart = Chart.getChart(this.chartId);
            if (strainChart != undefined) {
                strainChart.destroy();
            }
            let color = "#469685";
            this.createRadialChart(document.getElementById(this.chartId).getContext("2d"), 'Strain', this.strain, color, Constants.MAX_STRAIN);
        },
        createRadialChart(ctx, label, value, color, maxVal) {
            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: [value, maxVal - value],
                            backgroundColor: [color, '#364548'],
                            borderWidth: 0,
                        },
                    ],
                },
                options: {
                    cutout: '80%',
                    plugins: {
                        tooltip: { enabled: false },
                        legend: { display: false },
                        datalabels: {
                            display: true,
                            color: '#fff',
                            font: {
                                size: 20,
                                weight: 'bold',
                            },
                            formatter: (value, context) => {
                                if (context.dataIndex === 0) {
                                    return `${label}\n${value}`;
                                }
                                return '';
                            },
                        },
                    },
                },
            });
        }
    }
};
</script>

<style lang="scss" scoped>
canvas {
    border-radius: 50%;
    width: 110px !important;
    height: 110px !important;
}

.canvas-div-size {
    height: 110px;
    width: 110px;
}

.strain-container {
    background-color: #1C1D1F;
    border-radius: 0.5rem;
    height: 100%;
    text-align: center;
    padding-top: 4rem;
}

.title {
    font-size: 1rem;
    font-weight: bold;
}

// for min div
.canvas-div-size-min {
    padding-top: 1rem;
}

.strain-container-min {
    background-color: #1C1D1F;
    border-radius: 0.5rem;
    text-align: center;
    padding-top: 2rem;
    padding-bottom: 2rem;
}
</style>